export default __webpack_public_path__ + "static/Kate-edad9b79b8e0a392d15996e5ba3cb73c.jpeg";